export default (word: string) => {
  if (!word) {
    return ''
  }
  word = word.toString()
  return `${word.charAt(0)}`
}
